import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, NgForm, Validators } from "@angular/forms";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { Datamanager } from "src/app/model/Datamanager";
import { Page } from "src/app/model/Page";
import { ExportImportService } from "src/app/services/export-import.service";

@Component({
  selector: "app-secure-import-results",
  templateUrl: "./import-results.component.html",
  styleUrls: ["./import-results.component.scss"],
})
export class ImportResultsComponent implements OnInit {
  page: Page<Datamanager>;
  isLoading = false;
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  lotteryList: {[key: number]: string};
  reports: {[key: number]: string};
  selectedFile: File;
  @ViewChild('localForm') localForm : NgForm;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<Datamanager> = new MatTableDataSource();
  displayedColumns: string[] = [
    "key",
    "lottery",
    "actionTime",
    "status",
  ];
  pageSizeOptions: number[] = [10, 25, 100];
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;

  constructor(
    private router: Router,
    private exportImportService: ExportImportService
  ) {}

  ngOnInit(): void {
    this.loadData();
    this.form = new FormGroup({
      lotteryKey: new FormControl("", Validators.required),
      file: new FormControl(null, Validators.required),
    });
  }

  loadData() {
    this.isLoading = true;
    this.exportImportService.initImportResultsForm(this.currentPage, this.pageSize)
    .subscribe((data) => {
        this.page = data.datamanagerList;
        this.lotteryList = data.lotteryList;
        this.dataSource = new MatTableDataSource(data.datamanagerList.content);
        setTimeout(() => {
          this.paginator.pageIndex = this.currentPage;
          this.paginator.length = data.datamanagerList.totalElements;
        });
        this.isLoading = false;
      },
      (error) => {
        this.exportImportService.errorToast(error?.error?.message || error?.error?.errorMessage);
        this.isLoading = false;
      }
    );
  }

  onFileSelect(event) {
    this.selectedFile = event.target.files[0];
  }

  onSubmit() {
    if (this.form.valid) {
      this.isLoading = true;
      const reader = new FileReader();
      reader.readAsDataURL(this.selectedFile);
      reader.onload = () => {
        this.exportImportService
        .importResults(
          this.form.value.lotteryKey.key, 
          reader.result,
          this.selectedFile.name.substring(0, this.selectedFile.name.indexOf('.'))
        )
        .subscribe((data: any) => {
          this.isSubmitDisabled = false;
          if(data.status === 'SUCCESS') {
            this.localForm.resetForm({
              lotteryKey: "",
              file: null
            });
            this.selectedFile = null;

            setTimeout(() => {
              this.isLoading = false;
              this.ngOnInit();
            }, 2000);
          }
          else {
            this.isLoading = false;
            this.localForm.resetForm({
              lotteryKey: this.form.value.lotteryKey,
              file: null
            });
            this.selectedFile = null;
            this.exportImportService.errorToast(data.errorMessage);
          }
        }, error => {
          this.isLoading = false;
          this.localForm.resetForm({
            lotteryKey: "",
            importMasterType: "",
            file: null
          });
          this.selectedFile = null;
          this.isSubmitDisabled = false;
          console.log(error);
          this.exportImportService.errorToast(error?.error?.message||error?.error?.errorMessage, 5*1000);
        });
      };
    }
    else {
      this.isSubmitDisabled = false;
    }
  }

  refresh() {
    this.loadData();
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.loadData();
  }
}